export const apiTypeHelper = name => {
    return {
        ACTION: `${name}.ACTION`,
        SUCCESS: `${name}.SUCCESS`,
        FAILURE: `${name}.FAILURE`,
        PAGINATION: `${name}.PAGINATION`,
    }
}